import "./global.css";
import OneuxLayout from "./components/oneux-layout";
import { SdfBusyIndicator } from "@synerg/react-components";
import useLoadingEventListener from "./hooks/useEventListener";
import { useFetchProductsQuery, useFetchElasticSearchQuery, useFetchClaraDomainsQuery } from "./store";
import { buildQueryObj } from "./utility/FetchingUtils";

function App() {
  const isThemeLoading = useLoadingEventListener(
    "sdfLoaded",
    !window.SynergThemes
  );

  const { isLoading: isProductLoading } = useFetchProductsQuery();
  const { isLoading: isElasticLoading } = useFetchElasticSearchQuery(
    buildQueryObj({ index: "usecases" })
  );
  // Pre-fetch Clara domains at bootstrap so the nav header has them ready on first render.
  const { isLoading: isClaraLoading } = useFetchClaraDomainsQuery();

  const isLoading = isProductLoading || isThemeLoading || isElasticLoading || isClaraLoading;

  if (window.location.pathname.includes("/articles/preview/")) {
    return <OneuxLayout />;
  }
  if (window.location.pathname.includes("/usecases-preview/")) {
    return <OneuxLayout />;
  }

  return isLoading ? (
    <div className="app-load">
      <SdfBusyIndicator
        style={{ color: "#1a8099" }}
        size="xl"
        fullScreen={true}
      ></SdfBusyIndicator>
    </div>
  ) : (
    <OneuxLayout />
  );
}

export default App;
